import(/* webpackMode: "eager" */ "/home/ubuntu/download/697f4db3921dc90014cea113/arti_enterprise/src/app/projects/sonarbangla/page.tsx");
